import React from "react";
import { Button, Container, Grid, Paper } from "@mui/material";

const NoAccess = () => {
  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        marginTop: 4,
      }}
    >
      <Grid item xs={6}>
        <Paper
          elevation={1}
          sx={{
            padding: "20px",
            textAlign: "center",
          }}
        >
          <p>Your organization currently does not have access to this tool</p>
          <Button
            href="mailto:analytics@icer.org?subject=Access Request: Evidence Compendium"
            target="_blank"
          >
            Request Access
          </Button>
        </Paper>
      </Grid>
    </Container>
  );
};

export default NoAccess;
